import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType(); // 'PUSH' | 'REPLACE' | 'POP'

  useEffect(() => {
    // POP = browser back/forward — skip the reset so the user returns to
    // roughly where they were on that page. A hash (e.g. /admin/settings#
    // general, used by the Settings hub cards) means the destination wants
    // to land on a specific in-page anchor, not the top — resetting here
    // would race the target page's own scrollIntoView and always win since
    // this runs synchronously with 'instant' behavior. PUSH/REPLACE with no
    // hash: always start at the top.
    // behavior:'instant' skips smooth-scroll CSS on <html>.
    // document.body fallback covers Safari.
    if (navType === 'POP' || hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.body.scrollTop = 0;
  }, [pathname, hash, navType]);

  return null;
}
